/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowTurnRightUp: {
  name: 'arrow-turn-right-up';
  data: string;
} = {
  name: 'arrow-turn-right-up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.293 5.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L14 8.414V18a2 2 0 0 1-2 2H7a1 1 0 1 1 0-2h5V8.414l-2.293 2.293a1 1 0 0 1-1.414-1.414l4-4Z" fill="currentColor"/></svg>`,
};
